export const DEFAULT_FONT_FAMILY = "'proxima-nova', Helvetica, sans-serif";
